export default __webpack_public_path__ + "build/79b45b8bcee04de560986ae153557d53.svg";